// ============================================================
// BetaBanner — banner beta TOUJOURS visible, COLLE sous la NavBar
// ============================================================
// position: fixed top: 48px (exact NavBar height) + body class
// "with-beta-banner" qui ajoute padding-top: 44px au .merlin-app pour
// pousser le contenu pages vers le bas et ne pas le masquer derriere
// le banner.
// ============================================================

import { useState, useEffect } from 'react';
import FeedbackModal from './FeedbackModal';
import { useAuth } from '../context/AuthContext';
import { useApp } from '../context/AppContext';

const BANNER_CLASS = 'with-beta-banner';

export default function BetaBanner({ hidden = false }) {
  const { user } = useAuth();
  const { profile } = useApp();
  const [modalOpen, setModalOpen] = useState(false);
  const [navHeight, setNavHeight] = useState(48);

  // Ajoute / retire la classe sur body — push le contenu page sous le banner
  const bannerVisible = !hidden && !!user;
  useEffect(() => {
    if (bannerVisible) document.body.classList.add(BANNER_CLASS);
    else document.body.classList.remove(BANNER_CLASS);
    return () => document.body.classList.remove(BANNER_CLASS);
  }, [bannerVisible]);

  // Mesure la hauteur reelle de la navbar au runtime + observe les changes
  // (police qui charge, responsive breakpoints, etc.) — plus robuste que
  // de coder "48px en dur" qui peut etre faux selon le rendu exact.
  useEffect(() => {
    if (!bannerVisible) return;
    const measure = () => {
      const nav = document.querySelector('nav.merlin-nav');
      if (nav) {
        const rect = nav.getBoundingClientRect();
        setNavHeight(Math.round(rect.bottom)); // bottom = top + height + border
      }
    };
    measure();
    window.addEventListener('resize', measure);
    // ResizeObserver pour attraper les changes de hauteur de la nav
    const nav = document.querySelector('nav.merlin-nav');
    let ro;
    if (nav && typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(measure);
      ro.observe(nav);
    }
    return () => {
      window.removeEventListener('resize', measure);
      if (ro) ro.disconnect();
    };
  }, [bannerVisible]);

  if (!bannerVisible) return null;

  return (
    <>
      <div
        className="fixed left-0 right-0 px-4 py-2.5 text-sm font-medium shadow-md z-[45]"
        style={{
          top: `${navHeight}px`, // mesure dynamique — zero gap possible quelle que soit la hauteur reelle de la navbar
          background: 'linear-gradient(90deg, #fe8204 0%, #f59e0b 50%, #fe8204 100%)',
          color: 'white',
          backgroundSize: '200% 100%',
          animation: 'beta-shimmer 8s linear infinite',
        }}
      >
        <div className="max-w-5xl mx-auto flex items-center justify-between gap-3">
          <p className="truncate">
            <span className="font-bold">Merlin est en BETA</span>
            <span className="hidden sm:inline"> — des bugs sont possibles, dis-nous ce qui cloche</span>
            <span className="sm:hidden"> — des bugs ? dis-nous</span>
          </p>
          <button
            onClick={() => setModalOpen(true)}
            className="flex-shrink-0 px-3 py-1 rounded-lg bg-white text-orange text-xs font-bold hover:bg-white/90 transition-all whitespace-nowrap"
          >
            Remonter un bug →
          </button>
        </div>
        <style>{`
          @keyframes beta-shimmer {
            0% { background-position: 0% 50%; }
            100% { background-position: 200% 50%; }
          }
        `}</style>
      </div>

      <FeedbackModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        user={user}
        profile={profile}
      />
    </>
  );
}
